import { FeatureProviderContext } from '@origin-digital/features';

export const isFeatureEnabled = (featureContext: FeatureProviderContext, featureName: string) => {
  const feature = featureContext.features.find((feature) => feature.name === featureName);
  return feature && feature.enabled;
};
